import React from 'react';
import {
  TextField,
  InputAdornment,
  Button,
  Box,
  IconButton,
  Tooltip,
} from '@mui/material';
import { IconSearch, IconX } from '@tabler/icons';

const SearchBox = ({
  search = "",
  onSearchChange,
  onSearchClick,
  onClear,
  placeholder = "Search...",
  showClearButton = true,
  showSearchButton = true,
  minChars = 3,
  size = "medium",
  sx = {},
  ...props
}) => {
  const safeSearch = search || "";
  const hasSearchText = safeSearch.length > 0;
  const showMinCharsHint = safeSearch.length > 0 && safeSearch.length < minChars;

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', ...sx }}>
      <TextField
        value={safeSearch}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={placeholder}
        size={size}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconSearch size="1.1rem" />
            </InputAdornment>
          ),
          endAdornment: showClearButton && hasSearchText && (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={onClear}
                edge="end"
              >
                <IconX size="1rem" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        onKeyPress={(e) => {
          if (e.key === 'Enter' && safeSearch.length >= minChars) {
            onSearchClick();
          }
        }}
        sx={{ minWidth: '300px' }}
        {...props}
      />

      {showSearchButton && (
        <Tooltip
          title={safeSearch.length < minChars ? `Minimum ${minChars} characters required` : 'Search'}
        >
          <span>
            <Button
              variant="contained"
              color="primary"
              onClick={onSearchClick}
              disabled={safeSearch.length > 0 && safeSearch.length < minChars}
              size={size}
            >
              Search
            </Button>
          </span>
        </Tooltip>
      )}
    </Box>
  );
};

export default SearchBox;